import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Auth.css';

function Login() {
  const navigate = useNavigate();
  const [showCodeForm, setShowCodeForm] = useState(false);
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState('');
  const [codeError, setCodeError] = useState('');

  const formatPhoneNumber = (value) => {
    // Удаляем все нецифровые символы
    const cleaned = value.replace(/\D/g, '');
    
    // Применяем маску +7 (XXX) XXX-XX-XX
    let formatted = '+7';
    if (cleaned.length > 1) {
      formatted += ' (' + cleaned.substring(1, 4);
    }
    if (cleaned.length >= 5) {
      formatted += ') ' + cleaned.substring(4, 7);
    }
    if (cleaned.length >= 8) {
      formatted += '-' + cleaned.substring(7, 9);
    }
    if (cleaned.length >= 10) {
      formatted += '-' + cleaned.substring(9, 11);
    }
    
    return formatted;
  };

  const handlePhoneChange = (e) => {
    const input = e.target.value;
    const cleaned = input.replace(/\D/g, '');
    
    // Ограничиваем 11 цифрами (1 для кода страны + 10 для номера)
    if (cleaned.length <= 11) {
      setPhone(formatPhoneNumber(cleaned));
    }
  };

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();
    setPhoneError('');

    const cleaned = phone.replace(/\D/g, '');
    if (!cleaned || cleaned.length < 11) {
      setPhoneError('Укажите корректный номер телефона (11 цифр)');
      return;
    }

    setLoading(true);
    
    try {
      // Просто показываем форму с кодом
      setTimeout(() => {
        setShowCodeForm(true);
        setLoading(false);
      }, 300);
    } catch (err) {
      setLoading(false);
    }
  };

  const handleCodeSubmit = async (e) => {
    e.preventDefault();
    setCodeError('');

    if (!code || code.length !== 8) {
      setCodeError('Код должен содержать 8 символов');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('/api/v1/auth/telegram/verify-code', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code.toUpperCase() })
      });

      const data = await response.json();

      if (response.ok) {
        localStorage.setItem('access_token', data.access_token);
        localStorage.setItem('refresh_token', data.refresh_token);  // ✅ ИСПРАВЛЕНИЕ: сохраняем refresh token
        localStorage.setItem('user_data', JSON.stringify(data.user));
        localStorage.setItem('markapp_onboarding_seen', 'true');
        localStorage.setItem('markapp_onboarding_completed', 'true');

        

        setTimeout(() => {
          navigate('/', { replace: true });
        }, 500);
      } else {
        if (response.status === 401) {
          setCodeError('Неверный код. Проверьте код в Telegram.');
        } else {
          setCodeError(data.detail || 'Ошибка проверки кода');
        }
      }
    } catch (err) {
      console.error('Login error:', err);
      setCodeError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  const handleResendCode = () => {
    alert('Откройте @markapper_bot в Telegram и отправьте /start для получения нового кода');
  };

  const handleChangePhone = () => {
    setShowCodeForm(false);
    setCode('');
    setCodeError('');
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-side">
          <div className="auth-side-content">
            <a href="https://markapp.pro" className="auth-logo">
              <img src="/markapp-logo-white.png" alt="MarkApp" className="auth-logo-image login-logo" />
            </a>

            <h1 className="auth-side-title">С возвращением!</h1>
            <p className="auth-side-description">
              Войдите в свой аккаунт через Telegram код
            </p>

            <div className="auth-benefits">
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="5" y="11" width="14" height="10" rx="2" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.15)"/>
                    <path d="M8 11V7C8 5.67392 8.52678 4.40215 9.46447 3.46447C10.4021 2.52678 11.6739 2 13 2C14.3261 2 15.5979 2.52678 16.5355 3.46447C17.4732 4.40215 18 5.67392 18 7V11" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="13" cy="16" r="1.5" fill="white"/>
                  </svg>
                </div>
                <div className="benefit-text">
                  <div className="benefit-title">Безопасный вход</div>
                  <div className="benefit-desc">Через Telegram бота</div>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="white" strokeWidth="2" strokeLinejoin="round" fill="rgba(255,255,255,0.15)"/>
                  </svg>
                </div>
                <div className="benefit-text">
                  <div className="benefit-title">Быстро</div>
                  <div className="benefit-desc">Код приходит мгновенно</div>
                </div>
              </div>
              <div className="benefit-item">
                <div className="benefit-icon">
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="2" width="12" height="20" rx="2" stroke="white" strokeWidth="2" fill="rgba(255,255,255,0.15)"/>
                    <path d="M10 5H14" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                    <path d="M9 12L11 14L15 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <div className="benefit-text">
                  <div className="benefit-title">Без паролей</div>
                  <div className="benefit-desc">Одноразовый код из TG</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="auth-form-panel">
          <div className="auth-form-container">
            <div className="auth-header">
              <h2 className="auth-title">Вход в аккаунт</h2>
            </div>

            {/* Шаг 1: Ввод телефона */}
            <form 
              id="login-form-step1" 
              className="auth-form" 
              onSubmit={handlePhoneSubmit}
              style={{ display: showCodeForm ? 'none' : 'block' }}
              noValidate
            >
              <div className="form-group">
                <label htmlFor="login-phone" className="form-label">
                  Номер телефона <span className="required">*</span>
                </label>
                <div className="input-with-icon">
                  <span className="input-icon">📱</span>
                  <input
                    type="tel"
                    id="login-phone"
                    name="phone"
                    className="form-input"
                    placeholder="+7 (900) 123-45-67"
                    value={phone}
                    onChange={handlePhoneChange}
                    required
                    autoComplete="tel"
                  />
                </div>
                <div className="form-hint">
                  Укажите номер, привязанный к вашему Telegram аккаунту
                </div>
                {phoneError && <div className="form-error show" id="login-phone-error">{phoneError}</div>}
              </div>

              <button type="submit" className={`btn-primary btn-block btn-auth ${loading ? 'loading' : ''}`} id="send-code-btn" disabled={loading}>
                <span className="btn-text">Получить код в Telegram</span>
                {loading && (
                  <span className="btn-loader">
                    <svg className="spinner" width="20" height="20" viewBox="0 0 20 20">
                      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" fill="none" strokeDasharray="50" strokeDashoffset="25"/>
                    </svg>
                  </span>
                )}
              </button>
            </form>

            {/* Шаг 2: Ввод кода (скрыто по умолчанию) */}
            <form 
              id="login-form-step2" 
              className="auth-form" 
              onSubmit={handleCodeSubmit}
              style={{ display: showCodeForm ? 'block' : 'none' }}
              noValidate
            >
              <div className="code-sent-message">
                <div className="message-icon">✅</div>
                <div className="message-content">
                  <div className="message-title">Получите код в Telegram</div>
                  <div className="message-text">
                    Откройте <strong>@markapper_bot</strong> в Telegram и отправьте команду <strong>/start</strong> чтобы получить 8-значный код
                  </div>
                </div>
              </div>

              <a 
                href="https://t.me/markapper_bot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn btn-secondary"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.22 15.51 15.99C15.37 16.74 15.09 16.99 14.82 17.02C14.25 17.07 13.81 16.64 13.25 16.27C12.37 15.69 11.87 15.33 11.02 14.77C10.03 14.12 10.67 13.76 11.24 13.18C11.39 13.03 13.95 10.7 14 10.49C14.01 10.46 14.01 10.36 13.95 10.31C13.89 10.26 13.81 10.28 13.74 10.29C13.65 10.31 12.25 11.24 9.52 13.08C9.12 13.35 8.76 13.49 8.44 13.48C8.08 13.47 7.4 13.28 6.89 13.11C6.26 12.91 5.77 12.8 5.81 12.45C5.83 12.27 6.08 12.09 6.55 11.9C9.47 10.63 11.41 9.79 12.38 9.39C15.16 8.23 15.73 8.03 16.11 8.03C16.19 8.03 16.38 8.05 16.5 8.15C16.6 8.23 16.63 8.34 16.64 8.42C16.63 8.48 16.65 8.66 16.64 8.8Z" fill="currentColor"/>
                </svg>
                Открыть @markapper_bot
              </a>

              <div className="form-group">
                <label htmlFor="code" className="form-label">
                  Код из Telegram <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="code"
                  name="code"
                  className="form-input code-input"
                  placeholder="ABC12345"
                  value={code}
                  onChange={(e) => setCode(e.target.value.toUpperCase())}
                  required
                  maxLength={8}
                />
                {codeError && <div className="form-error show" id="code-error">{codeError}</div>}
              </div>

              <div className="code-actions">
                <button type="button" className="link-button" id="resend-code" onClick={handleResendCode}>
                  Отправить повторно
                </button>
                <button type="button" className="link-button" id="change-phone" onClick={handleChangePhone}>
                  Изменить номер
                </button>
              </div>

              <button type="submit" className={`btn-primary btn-block btn-auth ${loading ? 'loading' : ''}`} id="verify-code-btn" disabled={loading}>
                <span className="btn-text">Войти</span>
                {loading && (
                  <span className="btn-loader">
                    <svg className="spinner" width="20" height="20" viewBox="0 0 20 20">
                      <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" fill="none" strokeDasharray="50" strokeDashoffset="25"/>
                    </svg>
                  </span>
                )}
              </button>
            </form>

            {/* Ссылка на регистрацию */}
            <div className="auth-switch" id="signup-link">
              Еще нет аккаунта? <Link to="/signup">Зарегистрироваться</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
